import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App.js'
import './styles.css'
import 'maplibre-gl/dist/maplibre-gl.css'

const container = document.getElementById('root')
if (!container) throw new Error('The page has no #root to mount into.')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)

// Only in a built app: in development the service worker would serve stale
// modules and make every edit look like it did nothing.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
